import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ResponsiveService } from '@x/common/responsive';
import { CheckoutOrderState } from '@x/ecommerce-shop/app/checkout/state/checkout-order.state';
import { ShopOrderState } from '@x/ecommerce-shop/app/core/order/state/shop-order.state';
import { AvailabilityService } from '@x/ecommerce-shop/app/core/product/services/availability.service';
import { IProductItem } from '@x/ecommerce-shop/app/core/product/types/product-item';
import { IShopProductItemWithSearchContext } from '@x/ecommerce-shop/app/core/search/services/search.service';
import { UrlService } from '@x/ecommerce-shop/app/core/url/url.service';
import { combineLatest, Observable, race } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ProductListItemService {
  private orderState$ = race(
    this.store.select(ShopOrderState.order),
    this.store.select(CheckoutOrderState.order),
  );

  constructor(
    private store: Store,
    private responsiveService: ResponsiveService,
    private urlService: UrlService,
    private availabilityService: AvailabilityService,
  ) {}

  getView$(
    product: IShopProductItemWithSearchContext,
    mediaSize: number = 350,
  ): Observable<IProductItem> {
    return combineLatest([
      this.orderState$,
      this.responsiveService.observeIsBreakpoint({ min: 'MD' }),
    ]).pipe(
      map(([order, isBreakpoint]) => {
        const addToCartLabel = isBreakpoint ? 'Add to Bag' : 'Add';
        const detailUrl = this.urlService.productDetailUrl(product.id, product.slug);
        const variantAvailability = this.availabilityService.getProductVariantAvailability(
          product,
          order,
        );

        return {
          id: product.id,
          slug: product.slug,
          title: product.name,
          description: product.shortDescription,
          variation: product.variation,
          badges: product.badges,
          mainMedia: product.mainMedia,
          secondaryMedia: product.secondaryMedia,
          product,
          mediaSize,
          detailUrl,
          addToCartLabel,
          blurHash: product.thumbnailBase64,
          variantAvailability,
          searchContext: product.searchContext,
        };
      }),
    );
  }
}
